exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nimg[data-v-b9c9bc8c] {\n  height: 15vh;\n}\n", "", {"version":3,"sources":["/builds/datahouse2/doe/osss/medicaid-apps/nursing-service-logs-ui/version.vue"],"names":[],"mappings":";AAkBA;EACA,aAAA;CACA","file":"version.vue","sourcesContent":["<template>\n  <v-container fluid>\n    <div>\n      <!-- Automatically updated by .gitlab-ci.yml -->\n      Branch: uat/1.5.2-RC1<br />\n      Commit: b0705949<br />\n      Build Date: 2026-07-18T01:54:11Z\n    </div>\n  </v-container>\n</template>\n\n<script>\n/* eslint-disable indent */\n  export default {\n    name: 'Version'\n  };\n</script>\n<style scoped>\n  img {\n    height: 15vh;\n  }\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9c9bc8c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./version.vue
// module id = 9QZ1
// module chunks = 1